import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Alert,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Typography,
  SelectChangeEvent,
} from '@mui/material';
import type { CalendlyEvent } from '../hooks/useCalendlyIntegration';

interface CalendlySchedulingFlowProps {
  calendlyEvents: CalendlyEvent[];
  isCalendlyLoading: boolean;
  calendlyError: string | null;
  selectedCalendlyUrl: string;
  onCalendlyEventSelect: (e: SelectChangeEvent<string>) => void;
  hasError: boolean;
}

const CalendlySchedulingFlow: React.FC<CalendlySchedulingFlowProps> = ({
  calendlyEvents,
  isCalendlyLoading,
  calendlyError,
  selectedCalendlyUrl,
  onCalendlyEventSelect,
  hasError,
}) => {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 2, border: '1px dashed #ccc', borderRadius: '12px', bgcolor: '#f9f9f9' }}>
      {calendlyError === 'not_connected' ? (
        <Alert
          severity="warning"
          action={
            <Button color="inherit" size="small" onClick={() => navigate('/profile?tab=integrations')}>
              Connect Now
            </Button>
          }
        >
          Calendly is not connected.
        </Alert>
      ) : calendlyError ? (
        <Alert severity="error">{calendlyError}</Alert>
      ) : (
        <FormControl fullWidth required error={hasError}>
          <InputLabel>Select Calendly Event</InputLabel>
          <Select
            value={selectedCalendlyUrl}
            onChange={onCalendlyEventSelect}
            label="Select Calendly Event"
            disabled={isCalendlyLoading}
          >
            {calendlyEvents.map((evt) => (
              <MenuItem key={evt.uri} value={evt.scheduling_url}>
                {evt.name} ({evt.duration} min) - {evt.kind}
              </MenuItem>
            ))}
          </Select>
          {isCalendlyLoading && <FormHelperText>Loading event types...</FormHelperText>}
          {hasError && <FormHelperText error>Please select an event type</FormHelperText>}
        </FormControl>
      )}
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        We will email this booking link to the selected contacts.
      </Typography>
    </Box>
  );
};

export default CalendlySchedulingFlow;
